import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { push } from 'redux-first-history';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import HeaderTitle from 'Common/components/PageHeader/HeaderTitle';
import HeaderActions from 'Common/components/PageHeader/HeaderActions';
import HeaderContainer from 'Common/components/PageHeader/HeaderContainer';
import Filters from 'Common/components/filter/FiltersContainer';
import InvestorsListTable from 'Investors/components/InvestorsList/InvestorsListTable';
import useSmartResize from 'Common/hooks/table/useSmartResize';
import useInvestorsListFilterData from 'Investors/components/InvestorsList/hooks/useInvestorsListFilterData';
import { AlertWrapper, BoldText, StyledLink } from 'Impact/Impact';
import Icon from 'Common/components/icons/Icon';

const InvestorsList = () => {
	const { t } = useTranslation();
	const storedTableState = useSelector(state => state.tables.investors);
	const [shouldTableRender, setShouldTableRender] = useState(false);
	const dispatch = useDispatch();

	const location = useLocation();

	useEffect(() => {
		if (!shouldTableRender) {
			if (location.search === '' && storedTableState && storedTableState.url) {
				dispatch(push(`/investors${storedTableState.url}`));
			}
			setShouldTableRender(true);
		}
	}, [dispatch, storedTableState, location.search, shouldTableRender]);

	const filterButtonRef = useRef();
	const filtersData = useInvestorsListFilterData();

	const filtersRef = useRef();

	// eslint-disable-next-line
	const [forceUpdateCounter, setForceUpdateCounter] = useState(0);
	useSmartResize(filtersRef, setForceUpdateCounter);

	return (
		<>
			<Helmet>
				<title>{t('Investors')}</title>
			</Helmet>
			<HeaderContainer>
				<HeaderTitle>{t('Investors')}</HeaderTitle>
				<HeaderActions>
					<div ref={filterButtonRef}></div>
				</HeaderActions>
			</HeaderContainer>
			<AlertWrapper>
				<Icon icon="warning" size="small" />
				<h2>
					{t('As of today, ')}
					<BoldText>Pulse will be in frozen state. </BoldText>
					{t("This means that you won't be able to enter or edit any information until Pulse v2 is released. ")}
					<StyledLink
						href="https://www.notion.so/ecoligo/Pulse-migration-All-you-need-to-know-2572e2e27e4080678bf7f28ade021b6c"
						target="_blank"
						rel="noopener noreferrer"
					>
						{t('Read more ')}
					</StyledLink>
					{t('about this.')}
				</h2>
			</AlertWrapper>
			<div ref={filtersRef}>
				<Filters table="investors" buttonRef={filterButtonRef} filtersData={filtersData} />
			</div>

			{(shouldTableRender || !storedTableState?.url) && <InvestorsListTable />}
		</>
	);
};

export default InvestorsList;
